var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2947 6.86776C17.7102 7.41123 17.7102 8.14493 17.2947 8.68753C15.986 10.396 12.8461 13.9137 9.18027 13.9137C5.51443 13.9137 2.37453 10.396 1.0658 8.68753C0.863643 8.4273 0.753906 8.10716 0.753906 7.77764C0.753906 7.44812 0.863643 7.12798 1.0658 6.86776C2.37453 5.15931 5.51443 1.6416 9.18027 1.6416C12.8461 1.6416 15.986 5.15931 17.2947 6.86776V6.86776Z",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18051 10.4069C10.6329 10.4069 11.8102 9.22955 11.8102 7.77719C11.8102 6.32483 10.6329 5.14746 9.18051 5.14746C7.72815 5.14746 6.55078 6.32483 6.55078 7.77719C6.55078 9.22955 7.72815 10.4069 9.18051 10.4069Z",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e40ef5b34dd8a4ca5b32ca6b5be9ef2c.svg";
export { ForwardRef as ReactComponent };